
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/space",
      function () {
        return require("private-next-pages/space.tsx");
      }
    ]);
  